import { useEffect, useState } from 'react'

// True when the viewport is phone-width (<= 767px). Drives the mobile nav shell and any
// per-page mobile branching in later phases. SSR-safe.
const QUERY = '(max-width: 767px)'

export const useIsMobile = () => {
  const get = () => (typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia(QUERY).matches : false)
  const [isMobile, setIsMobile] = useState(get)
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mq = window.matchMedia(QUERY)
    const onChange = () => setIsMobile(mq.matches)
    mq.addEventListener('change', onChange)
    onChange()
    return () => mq.removeEventListener('change', onChange)
  }, [])
  return isMobile
}

export default useIsMobile
